import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import UserDateFormat from '../../../components/user-date-format/index';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const RefundCompletedUtcColumn = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { refundCompletedUtc } = fulfillment;

  if (!refundCompletedUtc) {
    return '';
  }

  return <UserDateFormat value={refundCompletedUtc} />;
};

RefundCompletedUtcColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const RefundCompletedUtc = {
  getMessageDescriptor: () => messages.refundCompletedUtc,
  id: 'refund-completed-utc',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <RefundCompletedUtcColumn fulfillmentId={data.id} />;
  },
};
